module.exports = __webpack_public_path__ + "img/chips100.657b7476.webp";